"use strict";
exports.__esModule = true;
//# sourceMappingURL=mailbox-proxy.type.js.map